export const cardsList = {
    filterByAuthorized: true,
    show: {
        insurance: true,
    },
};
